export const joinSearch = (url: string, params?: Record<string, string | number>) => {
    if (!params) return url;

    let search = Object.entries(params).map(([key, value]) => `${key}=${value}`).join('&');

    return search ? url + `?${search}` : url;
}